import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { cn } from '@Utils/cn';

export interface ResourceBarProps {
  children: React.ReactNode;
  actions?: React.ReactNode;
  detailsContent?: React.ReactNode;
  isDetailsExpanded: boolean;
  onToggleDetails: () => void;
  className?: string;
}

export function ResourceBar({
  children,
  actions,
  detailsContent,
  isDetailsExpanded,
  onToggleDetails,
  className,
}: ResourceBarProps) {
  return (
    <div
      className={
        className ?? 'dark flex w-full flex-col items-start bg-zinc-800'
      }
    >
      <div className="relative flex h-28 w-full items-center justify-between px-4 py-4">
        <div className="flex items-center gap-7">{children}</div>
        <div className="flex items-center gap-2.5">
          <Button
            variant="outline"
            size="sm"
            onClick={onToggleDetails}
            className="border-aoh-border text-aoh-ink bg-white dark:border-input dark:bg-zinc-800 dark:text-foreground"
          >
            {isDetailsExpanded ? (
              <ChevronDown className="size-4" />
            ) : (
              <ChevronUp className="size-4" />
            )}
            {isDetailsExpanded ? 'Hide Details' : 'Show Details'}
          </Button>
          {actions}
        </div>
      </div>
      {detailsContent && (
        <div
          className={cn(
            'w-full overflow-hidden transition-[max-height] duration-300 ease-in-out',
            isDetailsExpanded ? 'max-h-screen' : 'max-h-0',
          )}
        >
          {detailsContent}
        </div>
      )}
    </div>
  );
}
